import React, { Component, Fragment } from "react";
import styles from "./Header.css";
import MenuToggle from "../MenuToggle/MenuToggle";
import { Color, LIB } from "../../constants/consts-types";
import SearchToggle from "../SearchToggle/SearchToggle";
import PropTypes from "prop-types";
import DropdownTiny from "../DropdownTiny/DropdownTiny";
import { TypeRoute } from "../../constants/consts-prop-types";
import {
  isMobile,
  isSMKGuide,
  isDesktop,
  isHD,
} from "../../services/service-utils";
import MegaMenu from "./Components/MegaMenu/MegaMenu";
import MenuSection from "./Components/MenuSection";
import OpeningHours from "./Components/OpeningHours/OpeningHours";
import { LogoLink } from "./Components/LogoLink/LogoLink";
import MegaMenuLinksSection from "./Components/MegaMenu/Components/MegaMenuLinksSection";
import SearchInputAndSuggestions from "../Search/Components/SearchInputAndSuggestions";

class Header extends Component {
  static propTypes = {
    currentRoute: TypeRoute.isRequired,
    onSearchToggle: PropTypes.func.isRequired,
    onMenuToggle: PropTypes.func.isRequired,
    searchOpen: PropTypes.bool.isRequired,
    menuOpen: PropTypes.bool.isRequired,
    setActiveMenuIndex: PropTypes.func,
    isThy: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      heroColors: null,
      isMobile: isMobile(),
      isDesktop: isDesktop(),
      isHD: isHD(),
      showOpeningHours: false,
    };

    this.onResize = this.onResize.bind(this);
    this.setShowOpeningHours = this.setShowOpeningHours.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize() {
    this.setState({
      isMobile: isMobile(),
      isDesktop: isDesktop(),
      isHD: isHD(),
    });
  }

  setShowOpeningHours(open) {
    this.setState({ showOpeningHours: open });
  }

  render() {
    const {
      currentRoute,
      menuOpen,
      searchOpen,
      onSearchToggle,
      onMenuToggle,
      activeMenuIndex,
      setActiveMenuIndex,
      isThy,
    } = this.props;

    const {
      colors,
      heroColors,
      opening_hours,
      translations,
      site_data,
      language_name,
      hide_opening_hours,
      smk_guide: guide,
      menu,
    } = currentRoute;

    const { isHD, showOpeningHours } = this.state;
    const isGuide = isSMKGuide(currentRoute);

    const colorHeroForeground = isGuide
      ? "#F5F5F5"
      : heroColors && heroColors.foreground
      ? heroColors.foreground
      : colors.foreground;
    const colorHeroBackground =
      heroColors && heroColors.background
        ? heroColors.background
        : colors.background;

    const styleColor = {
      color:
        menuOpen || searchOpen || (!isHD && showOpeningHours)
          ? Color.GREY_LIGHT
          : colorHeroForeground,
      backgroundColor:
        menuOpen || searchOpen ? Color.GREY_DARK : colorHeroBackground,
    };

    const colorsHeader = {
      color: styleColor.color,
    };

    const colorsDropdown = {
      foreground: isGuide ? colors.foreground : colorHeroForeground,
      background: colorHeroBackground,
    };

    const headerClassName = `${
      menuOpen
        ? `${styles.headerMenuOpen} ${styles.Header_active}`
        : styles.Header
    }${isGuide ? ` ${styles.subBrand_Guide}` : ""}${
      activeMenuIndex !== undefined ? ` ${styles.Header_active}` : ""
    }`;

    const homeUrl = isGuide ? guide.landing_page_permalink : site_data.home_url;

    const _setActiveMenuIndex = (e, idx, item) => {
      if (item.children.length) {
        e.preventDefault();

        if (activeMenuIndex === idx) {
          setActiveMenuIndex(undefined);
        } else {
          setActiveMenuIndex(idx);
        }
      }
    };

    return (
      <Fragment>
        <header
          className={headerClassName}
          style={{
            ...colorsHeader,
            ...{ position: !isHD && showOpeningHours ? "fixed" : "absolute" },
          }}
        >
          <div
            className={[
              styles["Header-Row"],
              isThy && styles["Header-Row_thy"],
            ].join(" ")}
          >
            <div className={styles["Header-Row-Inner"]}>
              <LogoLink
                setActiveMenuIndex={_setActiveMenuIndex}
                colorsHeader={colorsHeader}
                homeUrl={homeUrl}
                isThy={isThy}
              />

              {isHD && (
                <MenuSection
                  currentRoute={currentRoute}
                  headerProps={this.props}
                  activeMenuIndex={activeMenuIndex}
                  setActiveMenuIndex={_setActiveMenuIndex}
                  onMenuToggle={onMenuToggle}
                />
              )}
            </div>

            <div className={styles.ActionsWrapper}>
              <div className={styles.Actions}>
                {!menuOpen && !searchOpen && translations && (
                  <Fragment>
                    <OpeningHours
                      opening_hours={opening_hours}
                      content={currentRoute.practical_menu_info}
                      isHD={isHD}
                      showOpeningHours={showOpeningHours}
                      setShowOpeningHours={this.setShowOpeningHours}
                    />
                    {(!showOpeningHours || isHD) && (
                      <Fragment>
                        <DropdownTiny
                          label={
                            (language_name && language_name.toUpperCase()) ||
                            "DA"
                          }
                          ariaLabel={LIB.select_language}
                          colors={colorsDropdown}
                          // className={styles.LanguageSelector}
                          setShowOpeningHours={this.setShowOpeningHours}
                        >
                          {Object.values(translations).map((t, idx) => (
                            <a
                              key={idx}
                              href={`${t.url}`}
                              title={`${LIB.select_language} ${t.language_name}`}
                              lang={t.language_code}
                            >
                              {t.language_name && t.language_name.toUpperCase()}
                            </a>
                          ))}
                        </DropdownTiny>
                        <div>
                          <SearchToggle onSearchToggle={onSearchToggle} />
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}

                {(!isHD || menuOpen || searchOpen) && (
                  <MenuToggle
                    isOpen={menuOpen || searchOpen || showOpeningHours}
                    onMenuToggle={
                      showOpeningHours
                        ? () => {
                            this.setShowOpeningHours(false);
                          }
                        : () => {
                            onMenuToggle();
                          }
                    }
                    style={{
                      display: !(menuOpen || searchOpen || showOpeningHours)
                        ? "block"
                        : "none",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </header>
        {isHD && (
          <MegaMenu
            menu={menu}
            activeMenuIndex={activeMenuIndex}
            opening_hours={currentRoute.opening_hours}
            practical_menu_info={currentRoute.practical_menu_info}
            setActiveMenuIndex={setActiveMenuIndex}
            mode={searchOpen ? "other" : "normal"}
            onMenuToggle={onMenuToggle}
            isThy={isThy}
          >
            <SearchInputAndSuggestions
              isActive={searchOpen}
              searchOpen={searchOpen}
              searchUrl={currentRoute.site_data.search_url}
              langCode={currentRoute.language}
            />

            {!searchOpen && (
              <MegaMenuLinksSection
                menu={menu}
                activeMenuIndex={activeMenuIndex}
                setActiveMenuIndex={setActiveMenuIndex}
              />
            )}
          </MegaMenu>
        )}
      </Fragment>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js